import { memo } from "react";

function Radius_Icon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.8706 11.2283V12.7717C14.5928 13.2501 14.0912 13.5433 13.5433 13.5433C13.134 13.5433 12.7415 13.3807 12.452 13.0913C12.1626 12.8019 12 12.4093 12 12C12 11.5907 12.1626 11.1981 12.452 10.9087C12.7415 10.6193 13.134 10.4567 13.5433 10.4567C14.0912 10.4567 14.5928 10.7499 14.8706 11.2283Z"
        fill="currentColor"
      />
      <path d="M22 12L19 15V13H13.72V11H19V9L22 12Z" fill="currentColor" />
      <path
        d="M19.0711 19.0711C19.6944 18.4477 20.227 17.7505 20.6603 17H18.245C18.0621 17.2285 17.8658 17.4479 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12C4 9.87827 4.84285 7.84344 6.34315 6.34315C7.84344 4.84285 9.87827 4 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C17.8658 6.55213 18.0621 6.77148 18.245 7L20.6603 7.00005C20.2243 6.24482 19.6904 5.54822 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2C10.6868 2 9.38642 2.25866 8.17317 2.7612C6.95991 3.26375 5.85752 4.00035 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C5.85752 19.9997 6.95991 20.7362 8.17317 21.2388C9.38642 21.7413 10.6868 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711Z"
        fill="currentColor"
      />
      <path
        d="M7 9.02395H8.56037V9.79042C8.71723 9.55888 8.94014 9.37126 9.2291 9.22755C9.52632 9.07585 9.83591 9 10.1579 9H11V10.4132H10.1579C9.72033 10.4132 9.36533 10.5409 9.09288 10.7964C8.82043 11.0519 8.68421 11.3792 8.68421 11.7784V15H7V9.02395Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default memo(Radius_Icon);
